import { render, staticRenderFns } from "./BarCodes.vue?vue&type=template&id=6cf46b8a"
import script from "./BarCodes.vue?vue&type=script&lang=js"
export * from "./BarCodes.vue?vue&type=script&lang=js"
import style0 from "./BarCodes.vue?vue&type=style&index=0&id=6cf46b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports